import { Facebook, Mail } from 'lucide-react';

export default function Footer() {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-[#0D0D0D] py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/assets/img/logo-claypulse.jpg"
                alt="ClayPulse"
                className="w-10 h-10 rounded-lg object-cover"
              />
              <span className="text-white font-bold text-xl font-['Poppins'] tracking-tight">
                Clay<span className="text-[#FF6B35]">Pulse</span>
              </span>
            </div>
            <p className="text-[#A0A0A0] text-sm leading-relaxed max-w-xs">
              L'application de suivi de performance pour les tireurs de ball-trap. Skeet, Trap, DTL et plus.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-['Poppins'] font-semibold text-sm mb-4">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: 'Accueil', href: '#hero' },
                { label: 'Fonctionnalités', href: '#fonctionnalites' },
                { label: 'Tarifs', href: '#tarifs' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    data-testid={`footer-link-${link.href.slice(1)}`}
                    onClick={() => scrollTo(link.href)}
                    className="text-[#A0A0A0] text-sm hover:text-[#FF6B35] transition-colors duration-300"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h4 className="text-white font-['Poppins'] font-semibold text-sm mb-4">Légal</h4>
            <ul className="space-y-3 mb-6">
              <li>
                <a href="/cgu" data-testid="footer-cgu-link" className="text-[#A0A0A0] text-sm hover:text-[#FF6B35] transition-colors duration-300">
                  Conditions Générales d'Utilisation
                </a>
              </li>
              <li>
                <a href="/politique-de-confidentialite" data-testid="footer-privacy-link" className="text-[#A0A0A0] text-sm hover:text-[#FF6B35] transition-colors duration-300">
                  Politique de confidentialité
                </a>
              </li>
              <li>
                <a href="/manage-subscription" data-testid="footer-manage-sub-link" className="text-[#A0A0A0] text-sm hover:text-[#FF6B35] transition-colors duration-300">
                  Gérer mon abonnement
                </a>
              </li>
            </ul>

            <h4 className="text-white font-['Poppins'] font-semibold text-sm mb-4">Contact</h4>
            <div className="flex items-center gap-4">
              <a
                href="mailto:supportclaypulse@gmail.com"
                data-testid="footer-email"
                className="text-[#A0A0A0] hover:text-[#FF6B35] transition-colors duration-300"
                title="Email"
              >
                <Mail size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61574337570139&locale=fr_FR"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="text-[#A0A0A0] hover:text-[#FF6B35] transition-colors duration-300"
                title="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 text-center">
          <p className="text-[#A0A0A0] text-xs">
            &copy; 2026 ClayPulse. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
}
